<template>
<div>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <router-link class="navbar-brand" to="/">
        <img class="n-logo" width="130" height="40" src="img/logotipo_mod2.png" alt="U4CROWD" />
      </router-link>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item" v-if="!user">
        <a
          class="nav-link"
          href="#projects"
        >
          <p>{{ $t('menu.projects') }}</p>
        </a>
      </li>
      <li class="nav-item" v-if="!user">
        <a
          class="nav-link"
          href="#about"
        >
          <p>{{ $t('menu.about') }}</p>
        </a>
      </li>
      <li class="nav-item" v-if="!user">
        <n-button class="nav-link" type="secondary" @click.native="modals.login = true">
          {{$t('menu.login')}}
        </n-button>
      </li>
      <li class="nav-item" v-if="!user">
        <n-button class="nav-link" type="secondary" @click.native="modals.signup = true">
          {{$t('menu.signup')}}
        </n-button>
      </li>
      <li class="nav-item" v-if="!user">
        <a
          class="nav-link"
          rel="tooltip"
          title="Follow us on Twitter"
          data-placement="bottom"
          href="#"
          target="_blank"
        >
          <i class="fab fa-twitter"></i>
          <p class="d-lg-none d-xl-none">Twitter</p>
        </a>
      </li>
      <li class="nav-item" v-if="!user">
        <a
          class="nav-link"
          rel="tooltip"
          title="Like us on Facebook"
          data-placement="bottom"
          href="#"
          target="_blank"
        >
          <i class="fab fa-facebook-square"></i>
          <p class="d-lg-none d-xl-none">Facebook</p>
        </a>
      </li>
      <li class="nav-item" v-if="!user">
        <a
          class="nav-link"
          rel="tooltip"
          title="Follow us on Instagram"
          data-placement="bottom"
          href="#"
          target="_blank"
        >
          <i class="fab fa-instagram"></i>
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li>


    <li class="nav-item" v-if="user">
        <router-link class="nav-link" to="/panel/">
          <p>Dashboard</p>
        </router-link>
      </li>
      <drop-down
              tag="li"
              :title="username"
              class="nav-item"
      >
        <nav-link to="/panel/profile">
          <div v-if="user && user.img_profile == '' ">
            <i class="now-ui-icons business_badge"></i> {{$t('menu.profile')}}
          </div>
          <div v-if="user && user.img_profile !== '' " class="text-center">
            <el-image            
            :src="image_profile"
            fit="scale-down"></el-image>
            <br>
            <strong>{{$t('menu.profile')}}</strong>
          </div>
        </nav-link>
        <nav-link to="/panel/portfolio" v-roles="['user']">
          <i class="el-icon-s-cooperation"></i> {{$t('menu.investments')}}
        </nav-link>
        <nav-link to="/panel/portfolio" v-permission="['ACCESS_INVESTMENTS']">
          <i class="el-icon-s-cooperation"></i> {{$t('menu.portfolio')}}
        </nav-link>
        <nav-link to="/panel/settings" v-permission="['ACCESS_PANEL_MAGNAMENT']">
          <i class="now-ui-icons business_bulb-63"></i> {{$t('menu.dashboard')}}
        </nav-link>
        <nav-link to="/panel/help">
          <i class="now-ui-icons ui-1_zoom-bold"></i> {{$t('menu.help')}}
        </nav-link>
        <nav-link @click.native="logout">
          <i class="now-ui-icons ui-1_simple-remove"></i> {{$t('menu.logout')}}
        </nav-link>
      </drop-down>
      <li class="nav-item" v-if="user">
        <router-link  class="mdl-navigation__link mdl-badge" :to="{ name: 'Panel_Notifications' }">
          <el-badge v-if="countNotifications > 0" :value="countNotifications" :max="13" class="item">
            <i class="now-ui-icons ui-1_bell-53 text-white"></i>
          </el-badge>
          <el-badge v-if="countNotifications == 0" class="item">
            <i class="now-ui-icons ui-1_bell-53 text-white"></i>
          </el-badge>
        </router-link>
      </li>


      <li class="nav-item" :class="{ active: isActive('es') }">
        <a
          class="nav-link active"
          rel="tooltip"
          title="Español"
          data-placement="bottom"
          @click="changeLanguage('es')"
        >
          Español
        </a>
      </li>
      <li class="nav-item" :class="{ active: isActive('en-US') }">
        <a
          class="nav-link"
          rel="tooltip"
          title="Español"
          data-placement="bottom"
          @click="changeLanguage('en-US')"
        >
          English
        </a>
      </li>
    </template>
  </navbar>
  <div id="modals_content">
      <modal :show.sync="modals.login" header-classes="justify-content-center"
             type="notice">
        <h4 slot="header" class="title title-up">{{$t('menu.login')}}</h4>
        <template>
          <login-form v-on:show-signup="modals.login=false; modals.restore=false; modals.signup=true"  v-on:show-restore="modals.signup=false; modals.login=false; modals.restore=true;"></login-form>
        </template>
      </modal>

      <modal :show.sync="modals.signup" headerClasses="justify-content-center" type="notice">
        <h5 slot="header" class="title title-up">{{$t('menu.signup')}}</h5>
        <template>
          <signup-form v-on:show-login="modals.signup=false; modals.restore=false; modals.login=true"></signup-form>
        </template>
      </modal>

      <modal :show.sync="modals.restore" headerClasses="justify-content-center" type="notice">
        <h5 slot="header" class="title title-up">{{$t('menu.restore_password')}}</h5>
        <template>
          <restore-pass-form v-on:show-login="modals.signup=false; modals.restore=false; modals.login=true"></restore-pass-form>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink, Button, Modal } from '@/components';
import { Popover, Badge, Image } from 'element-ui';
import LoginForm from '../pages/components/LoginForm';
import SignupForm from '../pages/components/SignupForm';
import RestorePassForm from '../pages/components/RestorePassForm';

import Users from '@/providers/Users'
const userProvider = new Users()

export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    Modal,
    SignupForm,
    LoginForm,
    RestorePassForm,
    [Button.name]: Button,
    [Popover.name]: Popover,
    [Badge.name]: Badge,
    [Image.name]: Image
  },
  mounted(){
    if (this.$store.state && this.$store.state.user) {
      this.count()
    }
  },
  data() {
    return {
      modals: {
        login: false,
        signup: false,
        restore: false
      },
      activeL: this.$store.getters.getLocale,
      user: this.$store.state.user,
      username: (this.$store.state && this.$store.state.user) ? this.$store.state.user.name : null,
      portfolio: (this.$store.state && this.$store.state.user) ? (this.$store.state.user.role == 'USER' ? 'Mis Inversiones' : 'Mi Portafolio') : null,
      countNotifications: 0,
      image_profile: (this.$store.state && this.$store.state.user) ? this.$store.state.api_files + this.$store.state.user.img_profile : null
    };
  },
  methods: {
    changeLanguage (locale) {
      this.$i18n.locale = locale
      this.activeL = locale
    },
    isActive: function (l) {
      return this.activeL === l
    },
    logout: function (l) {
      this.$store.dispatch('LOGOUT');
    },
    count(){
      userProvider.getAlertsCount().then((response) => {
        let data = response.data
        if(data && data.total) {
          this.countNotifications = data.total
        }
      }).catch((err) => {
      })
    }
  }
};
</script>

<style scoped>
.item {
  margin-top: 10px;
  margin-right: 20px;
}
.item i{
  font-size: 18px;
}
</style>